import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Card, Tree, useTreeData } from "@velocity-ehs/component-library";
import FormSkeleton from "../../../sharedComponents/FormSkeleton";
import { Person } from "../Person";
import { useEffect, useState } from "react";

type WhereCardProps = {
  formMethods: UseFormReturn<Person, unknown>;
  isLoading: boolean;
  readOnly: boolean;
};

const WhereCard = ({
  formMethods,
  isLoading,
  readOnly,
}: WhereCardProps): React.ReactElement => {
  const { t } = useTranslation();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const { treeStore, isAllFetched: isTreeLoaded } = useTreeData();

  const { control, watch, setError, setValue, getValues } = formMethods;

  const primaryLocationValue = watch("primaryLocation");

  useEffect(() => {
    const value = getValues("primaryLocation");
    if (!value) return;
    treeStore.active.flatTree.forEach((location) => {
      if (value.id === location.id) {
        return setSelectedKeys(location.key);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryLocationValue, isTreeLoaded]);

  const handleTreeSelect = (e: any) => {
    setError("primaryLocation", null);
    setSelectedKeys(e.node.key);
    setValue(
      "primaryLocation",
      {
        id: e.node.id,
        value: e.node.id,
        label: e.node.label,
      },
      { shouldDirty: true }
    );
  };

  const onRemove = () => {
    setSelectedKeys([]);
    setValue("primaryLocation", null, { shouldDirty: true });
  };

  return (
    <Card
      title={t("person_form_where_card_title")}
      style={{ paddingBottom: "2px" }}
    >
      {isLoading ? (
        <FormSkeleton rows={5} />
      ) : (
        <>
          <Controller
            control={control}
            name="primaryLocation"
            render={() => (
              <Tree
                onSelect={handleTreeSelect}
                onRemove={onRemove}
                selectionKeys={selectedKeys}
                readOnly={readOnly}
              />
            )}
          />
        </>
      )}
    </Card>
  );
};

export default WhereCard;
